<template>
	<article class="activated">
		<list-filter />
		<list-container>
			<table class="table-main activated__list">
				<thead>
					<tr>
						<th
							v-for="th in thList"
							:key="th"
							:class="{
								'activated-list__name-th': th === '이름',
							}"
						>
							{{ th }}
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in getActivatedList" :key="item.idRegister">
						<td>{{ item.idx }}</td>
						<td>{{ item.idRegister }}</td>
						<td>
							<router-link :to="item.infoLink" class="link">
								{{ item.nickname }}
							</router-link>
						</td>
						<td>{{ item.grade }}</td>
						<td>{{ item.email }}</td>
						<td v-if="hasAuthority">{{ item.userName }}</td>
						<td v-if="hasAuthority">{{ item.userTel }}</td>
						<td>{{ item.createDate }}</td>
						<td>{{ item.lastDate }}</td>
						<td>{{ item.sns }}</td>
						<td>{{ item.gender }}</td>
						<td>{{ item.age }}</td>
						<td>{{ item.skinType }}</td>
						<td
							v-for="beautyProfileTypeItem in beautyProfileTypeList"
							:key="beautyProfileTypeItem.type"
							v-text="
								beautyProfileTitleFromIdList(
									item.beautyProfileList,
									beautyProfileTypeItem.type
								)
							"
						/>
						<td>
							<b
								:class="
									item.instaStatus === '연동'
										? 'color-green'
										: 'font-red'
								"
								v-text="item.instaStatus"
							/>
						</td>
						<td>{{ item.instaCate }}</td>
						<td>{{ item.isPickple ? 'Y' : 'N' }}</td>
                        <td>{{ item.isCertification ? 'Y' : 'N' }}</td>
						<td>
							{{ item.fcmToken.os }} /
							{{ item.fcmToken.appVersion }}
						</td>
						<td>{{ item.reviewCount }}</td>
						<td>{{ item.winCount }}</td>
						<td class="activated__list__has-img has-img">
							<i
								aria-hidden="true"
								:class="[
									'fa',
									hasImgIconClass(item.hasFileName),
								]"
							></i>
						</td>
					</tr>
				</tbody>
			</table>
		</list-container>
	</article>
</template>
<script>
	import { mapGetters } from 'vuex';
	import ListFilter from '@/components/register/ListFilter';
	import ListContainer from '@/components/register/ListContainer';
	import { beautyProfileTypeList } from '@/constants.js';
	import { beautyProfileTitleFromIdList } from '@/util.js';

	export default {
		name: 'ActivatedList',
		components: {
			ListFilter,
			ListContainer,
		},
		data() {
			return {
				beautyProfileTypeList,
				beautyProfileTitleFromIdList,
			};
		},
		computed: {
			...mapGetters('register', ['getActivatedList', 'hasAuthority']),
			thList() {
				const list = [
					'#',
					'회원번호',
					'닉네임',
					'회원등급',
					'이메일주소',
					'이름',
					'전화번호',
					'가입일시',
					'마지막 접속일시',
					'SNS연동',
					'성별',
					'나이',
					'피부타입',
					...beautyProfileTypeList.map(item => item.type),
					'인스타그램',
					'인스타그램 카테고리',
					'픽플',
                    '휴대폰 인증',
					'단말기',
					'리뷰수',
					'당첨수',
					'이미지',
				];
				return this.hasAuthority
					? list
					: list.filter(th => !['이름', '전화번호'].includes(th));
			},
			hasImgIconClass: () => hasImg =>
				hasImg
					? 'fa-check-circle has-img__icon--blue'
					: 'fa-times-circle has-img__icon--red',
		},
		beforeCreate() {
			this.$store.commit('register/changeState', [
				{
					key: 'keyList',
					value: [
						'idRegister',
						'email',
						'skinType',
						'recommendNickname',
						'reviewCountRange',
						'userName',
						'sns',
						'nickname',
						'gender',
						'ageRange',
						'createDateRange',
						'winCountRange',
						'userTel',
						'isBlind',
						'lastDateRange',
						'regionObj',
						'grade',
						'instagramCategory',
						'instagramActive',
						'beautyProfileIdList',
						'wishIdProduct',
						'isPickple',
                        'isCertification',
					],
				},
				{
					key: 'orderList',
					value: [
						{ id: 3, text: '최신등록순' },
						{ id: 4, text: '이전등록순' },
						{ id: 5, text: '이미지순' },
						{ id: 6, text: 'NO이미지순' },
						{ id: 7, text: '리뷰많은순' },
						{ id: 8, text: '리뷰적은순' },
						{ id: 9, text: '이벤트당첨순' },
						{ id: 10, text: '이벤트당첨역순' },
						{ id: 13, text: '최근접속순' },
						{ id: 14, text: '최근접속역순' },
					],
				},
				{ key: 'pageType', value: 'activated' },
				{ key: 'order', value: 3 },
				{ key: 'orderDefault', value: 3 },
				{ key: 'limit', value: 10 },
			]);
		},
	};
</script>
<style lang="scss" scoped>
	.has-img__icon--blue {
		color: $btn-blue;
	}

	.has-img__icon--red {
		color: $red;
	}

	.activated-list__name-th::after {
		content: '홍강표';
		display: block;
		height: 0;
		overflow: hidden;
	}
</style>
